import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  FlowsActions,
  clearCollectionComponentByIdMultilingual,
  getCollectionComponentByIdMultilingual,
  useContentDispatch,
} from '@wajeez-web/stores/content';
import { useNavigate } from 'react-router-dom';

import { CollectionComponentForm } from '../components/CollectionComponentForm';
import { useGetCollectionComponentByIdMultilingual } from '@wajeez-web/components/helpers';

export const EditCollectionComponentV2Page = () => {
  const { flowId, pageId } = useParams<{
    flowId: string;
    pageId: string;
  }>();

  const navigate = useNavigate();

  const contentDispatch = useContentDispatch();

  const collectionComponentDetailsMultilingual =
    useGetCollectionComponentByIdMultilingual();

  useEffect(() => {
    pageId && getCollectionComponentByIdMultilingual(pageId);

    return () => {
      clearCollectionComponentByIdMultilingual();
    };
  }, [pageId]);

  useEffect(() => {
    contentDispatch(FlowsActions.getFlowDetailsByIdAsync(Number(flowId)));
  }, []);

  return (
    <div>
      <CollectionComponentForm
        type="Edit"
        onSubmit={() => {
          navigate(`/flows/v2/${flowId}/pages/${pageId}`);
        }}
        onCancel={() => {
          navigate(`/flows/v2/${flowId}/pages/${pageId}`);
        }}
        collectionComponentTypeId={
          collectionComponentDetailsMultilingual.data?.typeId
        }
      />
    </div>
  );
};
